import { StyleSheet } from '@react-pdf/renderer';

const MIN_ROW_HEIGHT = 30;
const MIN_HEADING_ROW_HEIGHT = 22;

const styles = StyleSheet.create({
  header: {
    display: 'flex',
    backgroundColor: '#DFE2E7',
    minHeight: 24
  },
  headerText: {
    fontFamily: 'Noto Sans',
    fontSize: 12,
    fontWeight: 400,
    color: '#14151C',
    paddingTop: 4,
    paddingBottom: 4,
    paddingLeft: 4
  },
  headerTextContinued: {
    fontSize: 9,
    fontFamily: 'Noto Sans',
    fontWeight: 400,
    color: '#363948',
    textTransform: 'uppercase'
  },
  tableContainer: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%'
  },
  tableHeaderRow: {
    backgroundColor: '#F3F4F6',
    color: '#14151C',
    fontFamily: 'Noto Sans',
    fontSize: 10,
    alignItems: 'flex-end',
    minHeight: MIN_HEADING_ROW_HEIGHT
  },
  headerRowBorder: {
    height: 1,
    backgroundColor: '#DFE2E7',
    width: '100%',
    marginBottom: -1
  },
  tableHeaderCell: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-end',
    fontFamily: 'Noto Sans',
    fontSize: 10,
    minHeight: MIN_HEADING_ROW_HEIGHT
  },
  tableRow: {
    display: 'flex',
    flexDirection: 'row',
    width: '100%',
    borderTop: '1px solid #DFE2E7',
    flexShrink: 0
  },
  tableLastRow: {
    borderBottom: '1px solid #DFE2E7'
  },
  tableCell: {
    flex: 1,
    fontWeight: 'normal',
    fontFamily: 'Noto Sans',
    color: '#14151C',
    fontSize: 9,
    padding: 4,
    marginRight: 4,
    minHeight: MIN_ROW_HEIGHT
  },
  borderLine: {
    position: 'relative',
    height: 1,
    backgroundColor: '#C2C7D0',
    marginBottom: 4
  },
  continuedText: {
    position: 'relative',
    display: 'flex',
    width: '100%',
    fontSize: 9,
    fontFamily: 'Noto Sans',
    fontWeight: 400,
    color: '#4D5165',
    textTransform: 'uppercase',
    textAlign: 'right'
  },
  continuedTextWrapper: {
    height: 'auto',
    minHeight: 24,
    paddingBottom: 4
  }
});

export default styles;
